export const AUTH = 'AUTH/auth';
export const LOGIN = 'AUTH/login';
export const VERIFY_OTP = 'AUTH/verify_otp';
export const VERIFY_OTP_SOURCE = 'AUTH/verify_otp_source';
export const RESEND_OTP = 'AUTH/resend_otp';
export const MFA_LOGIN = 'AUTH/mfa_login';
export const LOGOUT = 'AUTH/logout';
export const FORGOT_PASS = 'AUTH/forgot_pass';
export const USER_PROFILE = 'AUTH/user_profile';
export const VERIFY_MOBILE = 'AUTH/verify_mobile';
export const RESET_PASSWORD = 'AUTH/RESET_PASSWORD';

export const GET_DEMO_LIST = 'DEMO/get_demo_list';
export const GET_DEMO_INFO = 'DEMO/get_demo_info';
export const CREATE_DEMO = 'DEMO/create_demo';
export const UPDATE_DEMO = 'DEMO/update_demo';

export const VERIFY_LOGIN = 'AUTH/verify_login';
export const GET_FEEDBACK_SETTINGS = 'AUTH/get_feedback_settings';
export const GET_LGU = 'AUTH/get_lgu';

export const FORM_DATA = {
  title: '',
  image_url: '',
  height: '',
};
